function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import init from "./init.js";
import { REMEMBER_REHYDRATED, REMEMBER_PERSISTED } from "./action-types.js";
import { combineReducers } from 'redux';
export * from "./types.js";
var rememberReducer = function rememberReducer(reducer) {
  var data = {
    state: {}
  };
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : data.state;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    if (action.type && (action.type === '@@INIT' || action.type.startsWith('@@redux/INIT'))) {
      data.state = _objectSpread({}, state);
    }
    var rootReducer = typeof reducer === 'function' ? reducer : combineReducers(reducer);
    switch (action.type) {
      case REMEMBER_REHYDRATED:
        data.state = rootReducer(_objectSpread(_objectSpread({}, data.state), action.payload || {}), {
          type: REMEMBER_REHYDRATED
        });
        return data.state;
      default:
        return rootReducer(state, action);
    }
  };
};
var rememberEnhancer = function rememberEnhancer(driver, rememberedKeys) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$prefix = _ref.prefix,
    prefix = _ref$prefix === void 0 ? '@@remember-' : _ref$prefix,
    _ref$serialize = _ref.serialize,
    serialize = _ref$serialize === void 0 ? function (data, key) {
      return JSON.stringify(data);
    } : _ref$serialize,
    _ref$unserialize = _ref.unserialize,
    unserialize = _ref$unserialize === void 0 ? function (data, key) {
      return JSON.parse(data);
    } : _ref$unserialize,
    _ref$persistThrottle = _ref.persistThrottle,
    persistThrottle = _ref$persistThrottle === void 0 ? 100 : _ref$persistThrottle,
    persistDebounce = _ref.persistDebounce,
    _ref$persistWholeStor = _ref.persistWholeStore,
    persistWholeStore = _ref$persistWholeStor === void 0 ? false : _ref$persistWholeStor;
  if (!driver) {
    throw Error('redux-remember error: driver required');
  }
  if (!Array.isArray(rememberedKeys)) {
    throw Error('redux-remember error: rememberedKeys needs to be an array');
  }
  var storeCreator = function storeCreator(createStore) {
    return function (rootReducer, initialState, enhancer) {
      var store = createStore(rootReducer, initialState, enhancer);
      init(store, rememberedKeys, {
        driver: driver,
        prefix: prefix,
        serialize: serialize,
        unserialize: unserialize,
        persistThrottle: persistThrottle,
        persistDebounce: persistDebounce,
        persistWholeStore: persistWholeStore
      });
      return store;
    };
  };
  return storeCreator;
};
export { rememberReducer, rememberEnhancer, REMEMBER_REHYDRATED, REMEMBER_PERSISTED };
//# sourceMappingURL=index.js.map